import { ref } from 'vue';
import { defineStore } from 'pinia';
import ApiService from '@/services/ApiService';
import { User } from '@/models/UserModels';
import { useCommonStore } from '@/stores/commonStore';

export const useUserStore: any = defineStore('userStore', () => {
  const commonStore = useCommonStore();

  const users = ref<User[]>(sessionStorage.getItem('users') != null ? JSON.parse(sessionStorage.users) : new Array<User>());

  async function getAllUsers(): Promise<void> {
    commonStore.setStatus({ ...commonStore.status, userLoading: true, userErrorMsg: '' });

    return ApiService.getAllUsers()
      .then((res) => {
        const data: User[] = res.data;

        users.value = data;
        sessionStorage.setItem('users', JSON.stringify(users.value));
      })
      .catch((err) => {
        console.error(err);
        commonStore.status.userErrorMsg = err.response.data.detail;
      })
      .finally(() => {
        commonStore.status.userLoading = false;
        commonStore.setStatus(commonStore.status);
      });
  }

  async function deleteUser(id: number): Promise<void> {
    commonStore.setStatus({ ...commonStore.status, userLoading: true, userErrorMsg: '' });

    return ApiService.deleteUser(id)
      .then(() => {
        users.value = users.value.filter((user: User) => user.id !== id);
        sessionStorage.setItem('users', JSON.stringify(users.value));
      })
      .catch((err) => {
        console.error(err);
        commonStore.status.userErrorMsg = err.response.data.detail;
      })
      .finally(() => {
        commonStore.status.userLoading = false;
        commonStore.setStatus(commonStore.status);
      });
  }

  async function addUserToList(data: User): Promise<void> {
    users.value.push(data);
    sessionStorage.setItem('users', JSON.stringify(users.value));
  }

  return {
    users,

    getAllUsers,
    deleteUser,

    addUserToList,
  };
});
